import React, { Fragment, useState, useEffect  } from "react";
import Topbar from "../layouts/TopBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tab } from '@mui/material';
import UserResources from "../resources/UserResources";
import moment from "moment";
import { toast } from "react-toastify";
import { loginSuccess, logout } from "../redux/actions/LoggedInAction";
import { connect } from "react-redux";
import {ACCESS_DENIED} from '../Messages'

function TeamBirthdays({isLoggedIn, loggedInUser, logout}){
    const [users, setUsers] = useState([])

    const loadUsers = () => {
        let resources = new UserResources()
        return resources.get_admin_birthday()
    }

    useEffect(() => {
        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Team Member Birthdays</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }                            
                        </div>
                    </div>
                </div>
            </div>
            

            <div id="main-container">
                <div class="content">
                {
                    isLoggedIn ?
                    <div className="container">
                        <div className="spacer-20"></div>

                        <div style={{borderRadius: '12px', overflow: 'hidden', marginBottom: '24px', border: '1px solid #e0e0e0'}}>
                            <img src="https://ik.imagekit.io/seyi/Tlc_Media/Site_Images/birthdayposter.jpg" style={{width: '100%', height: 'auto', display: 'block'}} alt=""/>
                        </div>

                        <TableContainer component={Paper} style={{boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px'}}>
                            <Table>
                                <TableHead>
                                <TableRow style={{backgroundColor: '#003165'}}>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}></TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>First Name</TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Last Name</TableCell>
                                    <TableCell style={{color: '#fff', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Birthday</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {users.map((user, idx) => (
                                    <TableRow key={user['id'] || idx} style={{backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                        <TableCell style={{padding: '8px'}}>
                                            <div style={{width: '48px', height: '48px', borderRadius: '50%', overflow: 'hidden', border: '3px solid #ffa800'}}>
                                                <img src={user['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                            </div>
                                        </TableCell>
                                        <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{user['firstname']}</TableCell>
                                        <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{user['lastname']}</TableCell>
                                        <TableCell style={{fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{moment(user['date_of_birth']).format('DD MMMM')}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className="spacer-20"></div>
                    </div>:<></>
                }
                </div>
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamBirthdays);